export const FONT_WEIGHTS_OP = [
    { value: 'light', label: 'Light', weight: 300 },
    { value: 'normal', label: 'Standard', weight: 400 },
    { value: 'bold', label: 'Bold', weight: 700 }
] as const;

export const FONT_SIZES_OP = [
    { value: 'small', label: 'S' },
    { value: 'medium', label: 'M' },
    { value: 'large', label: 'L' }
] as const;

export const GRID_DENSITY_OP = [
    { value: 'comfortable', label: 'Comfortable' },
    { value: 'compact', label: 'Compact' },
    { value: 'dense', label: 'Dense' }
] as const;
